import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackIntegrationModalActionClicked.meta';

export type UseTrackIntegrationModalActionClickedParams = {
  integration_id: string;
  integration_name: string;
  integration_section: string;
  action_kind: 'link' | 'contact-support';
  action_label: string;
  button_position: 'primary' | 'secondary';
};

export const useTrackIntegrationModalActionClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackIntegrationModalActionClicked = useCallback(
    (params: UseTrackIntegrationModalActionClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackIntegrationModalActionClicked };
};
